// DO NOT EDIT THIS FILE!!!
// Update it by running `rake javascript:update_constants`

export const MAX_HOSTS = 10;
